import { ORIENTATION_TYPE_OPTION_IDS } from 'commons/constants';

export const getBundleProductsWithOrientation = bundleProducts => {
  const processProducts = products =>
    products
      .map(product => {
        if (!product.options) {
          return { ...product, orientation: {} };
        }

        const orientationOption = product.options.find(opt =>
          ORIENTATION_TYPE_OPTION_IDS.includes(opt.id)
        );

        if (!orientationOption || !orientationOption.values[0]) {
          return { ...product, orientation: {} };
        }

        return orientationOption.values[0].option_values.map(item => ({
          ...product,
          orientation: {
            option_id: orientationOption.id,
            currentSelection: {
              id: item.id,
              value: item.value,
              sku: item.sku,
            },
            option: item,
          },
        }));
      })
      .flat();

  return processProducts(bundleProducts);
};
